import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import * as w from "react";
import { useContext as H } from "react";
import { f as T } from "./index-LyFokDcn.mjs";
import { c as F, m as C } from "./tss-DN0acMKN.mjs";
import { M as u, d as p } from "./constants-CnFYFetN.mjs";
import { F as S } from "./field-context-CFgvjLYL.mjs";
import { g as y, c as M } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { f as N } from "./formControlState-vgaj2ksH.mjs";
import { u as R } from "./useFormControl-C9UMlaFq.mjs";
import { m as q } from "./memoTheme-BzXKG_-k.mjs";
import { g as $ } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as j, u as k, c as U } from "./DefaultPropsProvider-CFfEbxdP.mjs";
function h(r) {
  return y("MuiFormHelperText", r);
}
const x = $("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var g;
const D = (r) => {
  const {
    classes: e,
    contained: o,
    size: s,
    disabled: i,
    error: a,
    filled: n,
    focused: l,
    required: c
  } = r, f = {
    root: ["root", i && "disabled", a && "error", s && `size${F(s)}`, o && "contained", l && "focused", n && "filled", c && "required"]
  };
  return U(f, h, e);
}, L = j("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: o
    } = r;
    return [e.root, o.size && e[`size${F(o.size)}`], o.contained && e.contained, o.filled && e.filled];
  }
})(q(({
  theme: r
}) => ({
  color: (r.vars || r).palette.text.secondary,
  ...r.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${x.disabled}`]: {
    color: (r.vars || r).palette.text.disabled
  },
  [`&.${x.error}`]: {
    color: (r.vars || r).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: e
    }) => e.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), B = /* @__PURE__ */ w.forwardRef(function(e, o) {
  const s = k({
    props: e,
    name: "MuiFormHelperText"
  }), {
    children: i,
    className: a,
    component: n = "p",
    disabled: l,
    error: c,
    filled: f,
    focused: A,
    margin: E,
    required: I,
    variant: O,
    ...b
  } = s, v = R(), t = N({
    props: s,
    muiFormControl: v,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), d = {
    ...s,
    component: n,
    contained: t.variant === "filled" || t.variant === "outlined",
    variant: t.variant,
    size: t.size,
    disabled: t.disabled,
    error: t.error,
    filled: t.filled,
    focused: t.focused,
    required: t.required
  };
  delete d.ownerState;
  const z = D(d);
  return /* @__PURE__ */ m.jsx(L, {
    as: n,
    className: M(z.root, a),
    ref: o,
    ...b,
    ownerState: d,
    children: i === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      g || (g = /* @__PURE__ */ m.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : i
  });
}), P = C({ name: "FormNote" })(({ constructs: r, palette: e, typography: o, mode: s }) => {
  var i, a;
  return T.ifFeature(
    "encore",
    {
      root: {
        color: r.text.neutral.weak,
        fontSize: (i = o.xsmall) == null ? void 0 : i.fontSize,
        lineHeight: (a = o.xsmall) == null ? void 0 : a.lineHeight,
        marginTop: 0,
        marginLeft: 0,
        outline: s === u.Dye ? `1px solid ${p.main}` : void 0,
        "&.Mui-disabled, &.Mui-error": {
          color: r.text.neutral.weak
        }
      },
      disabled: {
        color: r.text.neutral.weak
      },
      error: {},
      info: {},
      warning: {}
    },
    {
      root: {
        display: "block",
        color: e.gray[700],
        fontSize: o.teenie.fontSize,
        lineHeight: o.teenie.lineHeight,
        margin: "1px 0 0",
        outline: s === u.Dye ? `1px solid ${p.main}` : void 0
      },
      disabled: {
        color: e.gray[700]
      },
      error: {
        color: e.error.main,
        fill: e.error.main
      },
      info: {
        color: e.info.main,
        fill: e.info.main
      },
      warning: {
        color: e.warning.main,
        fill: e.warning.main
      }
    }
  );
}), oe = ({ id: r, ...e }) => {
  const { status: o, classes: s } = e, { classes: i, cx: a } = P(void 0, { props: { classesProp: s } }), { noteId: n, disabled: l } = H(S) ?? {};
  return n && (r = n), /* @__PURE__ */ m.jsx(
    B,
    {
      classes: { root: i.root, disabled: i.disabled },
      className: a({
        [i.root]: !0,
        [i.error]: o === "error",
        [i.warning]: o === "warning",
        [i.info]: o === "info"
      }),
      disabled: l,
      error: o === "error",
      id: r,
      variant: "standard",
      ...e,
      "data-fabric-component": "FormNote"
    }
  );
};
export {
  oe as F
};
//# sourceMappingURL=form-note-CbSVsgBQ.mjs.map
